// extracted by mini-css-extract-plugin
export default {"link":"link--0cdc7f3d","leftIcon":"leftIcon--587e0904","rightIcon":"rightIcon--c10a4549","withicon":"withicon--17c3632c"};